module.exports = __webpack_public_path__ + "files/8525ee374532e2489216a0afd72331e3.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-2.png
// module id = 531
// module chunks = 76